"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanCard = void 0;
const react_1 = __importDefault(require("react"));
const commons_v2_checkbox_1 = require("@experta/commons-v2.checkbox");
const lang = __importStar(require("../../lang.json"));
const utils_1 = require("./utils");
require("./plan-card.css");
const backgroundColorDefault = "#5C0F8B";
const colorDefault = "#6E6E6E";
;
/**
 * Main component.
 * @name planCard
 * @param {PlanCardProps}
 * @returns {<PlanCard />}
*/
const PlanCard = ({ id, name, price = "", coverages, recomended = false, color = backgroundColorDefault, selected = false, onChange = () => { }, assists, headerText = "", assistsHeight = "55px", coveragesHeight = "inherit", minAge = "", maxAge = "" }) => {
    return (react_1.default.createElement("div", { "data-testid": "plan-card-element", className: "card-flex-container" },
        react_1.default.createElement("div", { className: "d-md-grid card-container" + (selected ? " selected" : " ") + (recomended ? " grids-col-recomend" : " ") },
            react_1.default.createElement("div", { className: "center card-header-container", style: selected ? { backgroundColor: color } : { backgroundColor: colorDefault } },
                react_1.default.createElement("div", { className: "card-header" },
                    react_1.default.createElement(commons_v2_checkbox_1.Checkbox, { checked: selected, onChange: (e) => onChange(Number(e.target.value)) }),
                    recomended && (react_1.default.createElement("div", null, lang.recomended.toUpperCase())))),
            react_1.default.createElement("div", { className: "card-content" },
                react_1.default.createElement("div", { className: "center plan-name", style: selected ? { color: color } : { color: colorDefault } }, name),
                react_1.default.createElement("div", { className: "plan-price" },
                    react_1.default.createElement("span", { className: "bold" }, price.substring(0, price.indexOf(" "))),
                    " ",
                    react_1.default.createElement("span", { className: "plan-price-text" },
                        " ",
                        price.substring(price.indexOf(" ") + 1))),
                react_1.default.createElement("div", { className: "plan-coverages", style: selected ? { color: color, height: coveragesHeight } : { color: colorDefault, height: coveragesHeight } },
                    utils_1.utils.renderCoverages(coverages),
                    minAge !== "" &&
                        react_1.default.createElement("div", { className: "coverage" },
                            react_1.default.createElement("div", { className: "coverage-name" }, lang.minAge),
                            react_1.default.createElement("div", { className: "coverage-value" }, minAge)),
                    maxAge !== "" &&
                        react_1.default.createElement("div", { className: "coverage" },
                            react_1.default.createElement("div", { className: "coverage-name" }, lang.maxAge),
                            react_1.default.createElement("div", { className: "coverage-value" }, maxAge)))),
            react_1.default.createElement("div", { className: "card-footer", style: selected ? { backgroundColor: color, height: assistsHeight } : { backgroundColor: colorDefault, height: assistsHeight } }, utils_1.utils.renderAssists(assists))),
        react_1.default.createElement("div", { className: recomended ? "d-md-none card-container-mobile container-recomended-mobile selected" : "d-md-none card-container-mobile selected" },
            recomended && (react_1.default.createElement("div", { className: "center", style: selected ? { backgroundColor: color } : { backgroundColor: colorDefault } },
                react_1.default.createElement("div", { className: "card-header-mobile" },
                    react_1.default.createElement("div", null, lang.recomended.toUpperCase())))),
            react_1.default.createElement("div", { className: "card-content-mobile" },
                react_1.default.createElement("div", { className: "center plan-name-mobile", style: selected ? { color: color } : { color: colorDefault } }, name),
                react_1.default.createElement("div", { className: "center plan-price-mobile" },
                    react_1.default.createElement("span", { className: "bold" }, price.substring(0, price.indexOf(" "))),
                    " ",
                    price.substring(price.indexOf(" ") + 1)),
                react_1.default.createElement("div", { className: "plan-coverages", style: selected ? { color: color } : { color: colorDefault } },
                    coverages.map((item) => {
                        var _a;
                        return (react_1.default.createElement("div", { className: "coverage", key: item.name },
                            react_1.default.createElement("div", { className: "coverage-name" }, item.name),
                            react_1.default.createElement("div", { className: "coverage-value" }, item.value && `$${(_a = item.value) === null || _a === void 0 ? void 0 : _a.toLocaleString("es")}`)));
                    }),
                    minAge !== "" &&
                        react_1.default.createElement("div", { className: "coverage" },
                            react_1.default.createElement("div", { className: "coverage-name" }, lang.minAge),
                            react_1.default.createElement("div", { className: "coverage-value" }, minAge)),
                    maxAge !== "" &&
                        react_1.default.createElement("div", { className: "coverage" },
                            react_1.default.createElement("div", { className: "coverage-name" }, lang.maxAge),
                            react_1.default.createElement("div", { className: "coverage-value" }, maxAge)))),
            react_1.default.createElement("div", { className: "card-footer-mobile", style: selected ? { backgroundColor: color } : { backgroundColor: colorDefault } }, assists.map((assist) => {
                return react_1.default.createElement("span", { key: assist },
                    "+ ",
                    assist);
            })))));
};
exports.PlanCard = PlanCard;
//# sourceMappingURL=plan-card.js.map